"use strict";

$(document).ready(function () {
  openSchedulerDetailsPhysicianInit();
  openSchedulerDetailsLocationInit();
});
function openSchedulerDetailsPhysicianInit() {
  if ($('.open-scheduler-epic-physicians-detail-container').length > 0) {
    //Get Scehdule Data

    //First Check to see if this is a multi department provider and grab selected value. else get fallback
    var departmentId;
    if ($('.open-scheduler-epic-physicians-detail-container').length > 0) {
      var depDropDown = $('#openSchedulerEpicDropdownPhysician');
      if ($(depDropDown).length > 0) {
        departmentId = $(depDropDown).find(":selected").data("provider-department-id");
      } else {
        departmentId = $('#view-all-appointments').data("provider-department-id");
      }
    }
    var physicianId;
    var slotDate;
    if ($('#view-all-appointments').length > 0) {
      physicianId = $('#view-all-appointments').data("physician-id");
      slotDate = $('#view-all-appointments').data("slot-date");
    }
    var viewAllLink = document.getElementById('view-all-appointments');
    if ($(viewAllLink).length > 0) {
      viewAllLink.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = '/physicians/appointment?id=' + physicianId + '&dep=' + departmentId + '&dt=' + slotDate;
      });
    }
    var slotButtons = document.querySelectorAll('.open-scheduler-epic__time');
    if ($(slotButtons).length > 0) {
      //ie 11 support for forEach
      if (typeof NodeList.prototype.forEach !== 'function') {
        NodeList.prototype.forEach = Array.prototype.forEach;
      }
      slotButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var slotDate = $(this).data('slot-date');
          var slotIndex = $(this).data('slot-index');
          window.location.href = '/physicians/appointment?id=' + physicianId + '&dep=' + departmentId + '&dt=' + slotDate + '&si=' + slotIndex;
        });
      });
    }

    //fallback when no slots book appointment button is shown
    var bookAppointmentButton = document.getElementById('book-appointment-button');
    if ($(bookAppointmentButton).length > 0) {
      bookAppointmentButton.addEventListener('click', function (e) {
        e.preventDefault();
        var depId = $(this).data('provider-department-id');
        var physId = $(this).data('physician-id');
        window.location.href = '/physicians/appointment?id=' + physId + '&dep=' + depId;
      });
    }
  }
  if ($("#openSchedulerEpicDropdownPhysician").length > 0) {
    var OpenSchedulerContainer = document.querySelector('.open-scheduler-epic-physicians-detail-container');
    var OpenSchedulerPhysicianDetails = document.querySelector('.open-scheduler-epic-physicians-detail-inner-container');
    if ($(".custom-select-dropdown-open-scheduler").length > 0) {
      var x, i, j, l, ll, selElmnt, a, b, c;
      /*look for any elements with the class "custom-select":*/
      x = document.getElementsByClassName("custom-select-dropdown-open-scheduler");
      l = x.length;
      for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        ll = selElmnt.length;
        /*for each element, create a new DIV that will act as the selected item:*/
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.id = selElmnt.options[selElmnt.selectedIndex].id;
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        /*for each element, create a new DIV that will contain the option list:*/
        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");
        for (j = 1; j < ll; j++) {
          /*for each option in the original select element,
          create a new DIV that will act as an option item:*/
          c = document.createElement("DIV");
          c.innerHTML = selElmnt.options[j].innerHTML;
          c.id = selElmnt.options[j].id;
          c.addEventListener("click", function (e) {
            /*when an item is clicked, update the original select box,
              and the selected item:*/
            var y, i, k, s, h, sl, yl;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            sl = s.length;
            h = this.parentNode.previousSibling;
            var selectedOption = document.getElementById("content-" + this.id);
            $(".dropdown-select-content > div").removeClass("active");
            $(selectedOption).addClass("active");
            for (i = 0; i < sl; i++) {
              if (s.options[i].innerHTML == this.innerHTML) {
                s.selectedIndex = i;
                h.innerHTML = this.innerHTML;
                y = this.parentNode.getElementsByClassName("same-as-selected");
                yl = y.length;
                for (k = 0; k < yl; k++) {
                  y[k].removeAttribute("class");
                }
                this.setAttribute("class", "same-as-selected");
                break;
              }
            }
            h.click();

            //Disable subsequent clicks
            x[0].setAttribute("style", "pointer-events:none;");

            //Get Scehdule Data
            var departmentId = $('#openSchedulerEpicDropdownPhysician').find(":selected").data("provider-department-id");
            var physicianId = $('#openSchedulerEpicDropdownPhysician').find(":selected").data("physician-id");
            var apiUrl = "/api/sitecore/physicians/physicianopenscheduler?DepartmentId=" + departmentId + "&PhysicianId=" + physicianId;
            makeRequest(apiUrl, "POST", null, null, function (xhttp, isNetworkSuccess) {
              if (isNetworkSuccess) {
                OpenSchedulerPhysicianDetails.remove();
                var $container = $(OpenSchedulerContainer);
                $container.append(xhttp.responseText);
                openSchedulerDetailsPhysicianInit();
              }
            });
          });
          b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function (e) {
          /*when the select box is clicked, close any other select boxes,
            and open/close the current select box:*/
          e.stopPropagation();
          closeAllSelect(this);
          this.nextSibling.classList.toggle("select-hide");
          this.classList.toggle("select-arrow-active");
        });
      }
      function closeAllSelect(elmnt) {
        /*a function that will close all select boxes in the document,
        except the current select box:*/
        var x,
          y,
          i,
          xl,
          yl,
          arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
          if (elmnt == y[i]) {
            arrNo.push(i);
          } else {
            y[i].classList.remove("select-arrow-active");
          }
        }
        for (i = 0; i < xl; i++) {
          if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
          }
        }
      }
      /*if the user clicks anywhere outside the select box,
      then close all select boxes:*/
      document.addEventListener("click", closeAllSelect);
    }
  }
}
function openSchedulerDetailsLocationInit() {
  if ($('.open-scheduler-epic-facility-location-detail-container').length > 0) {
    //Get Scehdule Data

    //First Check to see if this is a multi department provider and grab selected value. else get fallback
    var departmentId;
    if ($('.open-scheduler-epic-facility-location-detail-container').length > 0) {
      var depDropDown = $('#openSchedulerEpicDropdownLocation');
      if ($(depDropDown).length > 0) {
        departmentId = $(depDropDown).find(":selected").data("provider-department-id");
      } else {
        departmentId = $('#view-all-appointments').data("provider-department-id");
      }
    }
    var physicianId;
    var slotDate;
    if ($('#view-all-appointments').length > 0) {
      physicianId = $('#view-all-appointments').data("physician-id");
      slotDate = $('#view-all-appointments').data("slot-date");
    }
    var viewAllLink = document.getElementById('view-all-appointments');
    if ($(viewAllLink).length > 0) {
      viewAllLink.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = '/locations/appointment?id=' + physicianId + '&dep=' + departmentId + '&dt=' + slotDate;
      });
    }
    var slotButtons = document.querySelectorAll('.open-scheduler-epic__time');
    if ($(slotButtons).length > 0) {
      //ie 11 support for forEach
      if (typeof NodeList.prototype.forEach !== 'function') {
        NodeList.prototype.forEach = Array.prototype.forEach;
      }
      slotButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var slotDate = $(this).data('slot-date');
          var slotIndex = $(this).data('slot-index');
          window.location.href = '/locations/appointment?id=' + physicianId + '&dep=' + departmentId + '&dt=' + slotDate + '&si=' + slotIndex;
        });
      });
    }

    //fallback when no slots book appointment button is shown
    var bookAppointmentButton = document.getElementById('book-appointment-button');
    if ($(bookAppointmentButton).length > 0) {
      bookAppointmentButton.addEventListener('click', function (e) {
        e.preventDefault();
        var depId = $(this).data('provider-department-id');
        var physId = $(this).data('physician-id');
        window.location.href = '/locations/appointment?id=' + physId + '&dep=' + depId;
      });
    }
  }
  if ($("#openSchedulerEpicDropdownLocation").length > 0) {
    var OpenSchedulerContainer = document.querySelector('.open-scheduler-epic-facility-location-detail-container');
    var OpenSchedulerFacilityLocationDetails = document.querySelector('.open-scheduler-epic-facility-location-detail-inner-container');
    if ($(".custom-select-dropdown-open-scheduler").length > 0) {
      var x, i, j, l, ll, selElmnt, a, b, c;
      /*look for any elements with the class "custom-select":*/
      x = document.getElementsByClassName("custom-select-dropdown-open-scheduler");
      l = x.length;
      for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        ll = selElmnt.length;
        /*for each element, create a new DIV that will act as the selected item:*/
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.id = selElmnt.options[selElmnt.selectedIndex].id;
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        /*for each element, create a new DIV that will contain the option list:*/
        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");
        for (j = 1; j < ll; j++) {
          /*for each option in the original select element,
          create a new DIV that will act as an option item:*/
          c = document.createElement("DIV");
          c.innerHTML = selElmnt.options[j].innerHTML;
          c.id = selElmnt.options[j].id;
          c.addEventListener("click", function (e) {
            /*when an item is clicked, update the original select box,
              and the selected item:*/
            var y, i, k, s, h, sl, yl;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            sl = s.length;
            h = this.parentNode.previousSibling;
            var selectedOption = document.getElementById("content-" + this.id);
            $(".dropdown-select-content > div").removeClass("active");
            $(selectedOption).addClass("active");
            for (i = 0; i < sl; i++) {
              if (s.options[i].innerHTML == this.innerHTML) {
                s.selectedIndex = i;
                h.innerHTML = this.innerHTML;
                y = this.parentNode.getElementsByClassName("same-as-selected");
                yl = y.length;
                for (k = 0; k < yl; k++) {
                  y[k].removeAttribute("class");
                }
                this.setAttribute("class", "same-as-selected");
                break;
              }
            }
            h.click();

            //Disable subsequent clicks
            x[0].setAttribute("style", "pointer-events:none;");

            //Get Scehdule Data
            var departmentId = $('#openSchedulerEpicDropdownLocation').find(":selected").data("provider-department-id");
            var physicianId = $('#openSchedulerEpicDropdownLocation').find(":selected").data("physician-id");
            var apiUrl = "/api/sitecore/locations/facilitylocationopenscheduler?DepartmentId=" + departmentId + "&PhysicianId=" + physicianId;
            makeRequest(apiUrl, "POST", null, null, function (xhttp, isNetworkSuccess) {
              if (isNetworkSuccess) {
                OpenSchedulerFacilityLocationDetails.remove();
                var $container = $(OpenSchedulerContainer);
                $container.append(xhttp.responseText);
                openSchedulerDetailsLocationInit();
              }
            });
          });
          b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function (e) {
          /*when the select box is clicked, close any other select boxes,
            and open/close the current select box:*/
          e.stopPropagation();
          closeAllSelect(this);
          this.nextSibling.classList.toggle("select-hide");
          this.classList.toggle("select-arrow-active");
        });
      }
      function closeAllSelect(elmnt) {
        /*a function that will close all select boxes in the document,
        except the current select box:*/
        var x,
          y,
          i,
          xl,
          yl,
          arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
          if (elmnt == y[i]) {
            arrNo.push(i);
          } else {
            y[i].classList.remove("select-arrow-active");
          }
        }
        for (i = 0; i < xl; i++) {
          if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
          }
        }
      }
      /*if the user clicks anywhere outside the select box,
      then close all select boxes:*/
      document.addEventListener("click", closeAllSelect);
    }
  }
}